import { userSections } from "../../../enums/userSections";
import { UserModel } from "../../../modules/auth/models/UserModel";
import { DEFAULT_ROUTE } from "../../../routing/routes.config";

export const GetRedirect = (user: UserModel) => {
    const _default = user.sections.find(s => !!s.isDefault);
    if(!_default)
        return DEFAULT_ROUTE;
    switch (_default.section) {
        case userSections.CLAIM:
            return "/claims/dashboard/";
        default:
            return "/assets/chat";
    }
}